<script setup lang="ts">
import logo from '@/assets/alpin-capital-logo.svg'

const props = defineProps<{
  height?: string
  width?: string
}>()

const height = props.height ?? 'auto'
const width = props.width ?? '100'
</script>

<template>
  <div>
    <img alt="Logo Alpin Capital" :src="logo" :height="height" :width="width" />
  </div>
</template>
